import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { QuickReply } from '@connect-x-app/shared-domain-models';

import { useQuickReplyTable } from '../../../../../shared/hooks/useQuickReplyTable';
import { IndexableQuickReply } from '../../../../../shared/models/indexableQuickReply';
import { mapQuickRepliesToIndexableQuickReplies } from '../../../../../shared/utils/indexableQuickReplyMapper.util';
import { useGetRole, useUpdateRole } from '../../../../queries';

type Props = {
  renderCheckbox: boolean;
};

export const useRoleQuickReplyContentTable = ({ renderCheckbox }: Props) => {
  const { roleId } = useParams();

  const { data, isLoading: isFetchLoading, refetch } = useGetRole(roleId ?? '');
  const { isPending: isMutateLoading, mutate } = useUpdateRole();

  const [state, setState] = useState<IndexableQuickReply[]>([]);

  useEffect(() => {
    setState(data?.quickReplies?.map(mapQuickRepliesToIndexableQuickReplies) ?? []);
  }, [data?.quickReplies]);

  const table = useQuickReplyTable({
    data: state,
    renderCheckbox,
  });

  const itemsToDelete = table.getSelectedRowModel().rows.map(({ id }) => id);

  return {
    create: async (quickReply: QuickReply) => {
      if (data) {
        mutate({
          ...data,
          quickReplies: data.quickReplies ? [...data.quickReplies, quickReply] : [quickReply],
        });
      }

      await refetch();
    },
    isLoading: isFetchLoading || isMutateLoading,
    quickReplies: state,
    remove: async () => {
      const newState = state.filter(({ index }) => !itemsToDelete.includes(`${index}`));
      if (data) {
        mutate({
          ...data,
          quickReplies: newState,
        });
      }

      table.resetRowSelection();
      await refetch();
    },
    selectedItems: itemsToDelete,
    table,
    updateRoleQuickReply: (quickReply: IndexableQuickReply) => {
      if (data) {
        const updatedQuickReplies = data?.quickReplies?.map((item, i) => (i === quickReply.index ? quickReply : item)) ?? [];
        mutate({
          ...data,
          quickReplies: updatedQuickReplies,
        });
      }
    },
  };
};
